import { observable } from "mobx";
import ExemptionChangeRestrictionLevel from "./exemptionChangeRestrictionLevel";
import ExemptionChangeActionRejectionReason from "./exemptionChangeActionRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionChangeActionResponse {
  /**
   * Indicates if action on charge is allowed.
   */
  @observable
  isAllowed!: boolean;

  @observable
  restrictionLevel?: ExemptionChangeRestrictionLevel;

  @observable
  rejectionReason?: ExemptionChangeActionRejectionReason;
}
